import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUp, Mail } from 'lucide-react';

const PageActions = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Request More Info CTA */}
      <Link
        to="/contact"
        className="fixed bottom-24 right-6 z-40 bg-[#d4a574] hover:bg-[#c49563] text-[#f5f1e8] px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center space-x-2 font-light"
        style={{ fontFamily: 'Inter, sans-serif' }}
      >
        <Mail size={18} />
        <span className="hidden md:inline">Request More Info</span>
      </Link>

      {/* Back to Top Button */}
      {showBackToTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-40 bg-[#3a2f28] hover:bg-[#2a231d] text-[#f5f1e8] p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
          aria-label="Back to top"
        >
          <ArrowUp size={20} />
        </button>
      )}
    </>
  );
};

export default PageActions;
